import { Box, CircularProgress } from '@mui/material';

const Loader = () => (
  <Box
    sx={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100%',
      width: '100%',
      flex: 1
    }}
  >
    <CircularProgress />
  </Box>
);

export default Loader;
